export default function pushEvent(e) {
	if( !window.dataLayer ) {
		console.warn("Cannot push event", e);
		return false;
	}

	if ( window.location.host.endsWith('localhost') ) {
		console.debug("Push event Skipped (localhost)", e)
		return false;
	}

	window.dataLayer.push(e);
	console.debug("Push event", e)
}